export default [
    {
        path: '/admin/setup-banners',
        name: 'setup-banner',
        meta: { requiresAuth: true },
        component: () => import('@/pages/website/setup-banner/index.vue')
    }
]